export class EventEmitter {
  private eventListeners = new Map<string, Set<(event: unknown) => void>>();

  emit(type: string, event?: unknown) {
    const listeners = this.eventListeners.get(type);
    listeners?.forEach((listener) => listener(event));
  }

  addEventListener(type: string, listener: (event: any) => void) {
    let listeners = this.eventListeners.get(type);
    if (!listeners) {
      listeners = new Set();
      this.eventListeners.set(type, listeners);
    }
    listeners.add(listener);
  }

  removeEventListener(type: string, listener: (event: any) => void) {
    this.eventListeners.get(type)?.delete(listener);
  }
}
